import {
    //All Product Icons
    AutoProduct,
    BundleProduct,
    Column,
    CommercialProduct,
    CondoProduct,
    Container,
    cssVar,
    Grid,
    getSize,
    HomeProduct,
    Label,
    LandlordProduct,
    MotorcycleProduct,
    PleasurecraftProduct,
    RoommateProduct,
    Row,
    RVProduct,
    SecondaryButton,
    TenantProduct,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ProfileSummaryDiscounts from '../../CommonComponents/DiscountBadges';

const PolicyFactsContainer = styled(Container)`
    border: 1px solid ${cssVar.colorStrokeLight};
    border-radius: 4px;
`;

const HeaderContainer = styled(Container)`
    align-items: center;
`;

const ProfileSummaryAction = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    const getProductIcon = (product, color) => {
        switch (product) {
            case 'auto':
            case 'flux-commauto':
                return <AutoProduct color={color} />;
            case 'bundle':
                return <BundleProduct color={color} />;
            case 'condo':
                return <CondoProduct color={color} />;
            case 'home':
                return <HomeProduct color={color} />;
            case 'landlord':
                return <LandlordProduct color={color} />;
            case 'motorcycle':
                return <MotorcycleProduct color={color} />;
            case 'roomate':
                return <RoommateProduct color={color} />;
            case 'tenant':
                return <TenantProduct color={color} />;
            case 'rv':
                return <RVProduct color={color} />;
            case 'pleasurecraft':
                return <PleasurecraftProduct color={color} />;
            default:
                return <CommercialProduct color={color} />;
        }
    };

    const policyStatus = props.policySummary.status;
    const insurerSelected =
        policyStatus === 'quoteAccepted' ||
        policyStatus === 'bindRequested' ||
        policyStatus === 'bound' ||
        policyStatus === 'issued';

    const _insurer =
        insurerSelected && props.policySummary.participants.insurer?.commercialName?.name
            ? props.policySummary.participants.insurer.commercialName.name
            : '';

    const _currency = 'CAD';
    const _culture = props.context.session.culture;

    const _premiumAmount = props.policySummary.estimatedAnnualPremium.value;
    const _taxesAmount = props.policySummary.estimatedTaxes.value;
    const _feesAmount = props.policySummary.estimatedFees.value;
    const clientFirstName = props.policySummary?.participants?.insured?.party?.name?.firstName ?? '';
    const clientLastName = props.policySummary?.participants?.insured?.party?.name?.lastName ?? '';
    const clientAddress = props.policySummary?.participants?.insured?.party?.address?.formattedAddress ?? '';
    const clientContact = props.policySummary?.participants?.insured?.party?.communication?.phone?.fullNumber ?? '';
    const product = props.policySummary.productName;
    const priorPolicy = props.policySummary?.priorPolicyReference?.guid;
    const _policyNo = props.policySummary.number;
    const _expiryDate = props.policySummary.formattedExpiryDate;
    const _annualPremium = props.policySummary.formattedEstimatedAnnualPremium;
    const _expiresInDays = props.policySummary.expiresInDays;

    if (props.policySummary.risks) {
        for (let i = 0; i < props.policySummary.risks.length; i++) {
            const risk = props.policySummary.risks[i];
            for (let j = 0; j < risk.coverages.length; j++) {
                const _coverage = risk.coverages[0];
            }
        }
    }

    const getInsuranceTranslationId = () => {
        const baseId = 'Profile_Renewal_Action.';
        switch (product) {
            case 'flux-commauto':
                return `${baseId}fluxCommautoInsurance`;
            default:
                return `${baseId + product}Insurance`;
        }
    };

    return (
        <PolicyFactsContainer top={sizes.sm} bottom={sizes.sm}>
            <Grid>
                {/*Heading*/}
                <Row>
                    <Column gutterLeft={getSize(sizes.sm)}>
                        <HeaderContainer inline>
                            {getProductIcon(product, cssVar.colorStrokeDark)}
                            <Label
                                size={sizes.lg}
                                top={sizes.xs}
                                bold
                                bottom={sizes.xs}
                                left={sizes.xs}
                                text={<FormattedMessage id={getInsuranceTranslationId()} />}
                            />
                        </HeaderContainer>
                    </Column>
                </Row>
                {/*Information Row 1*/}
                <Row>
                    <Column xs={4}>
                        <Container horizontalAlignment={alignments.left} verticalAlignment={alignments.center}>
                            <Label
                                bold
                                left={sizes.xs}
                                textAlign={alignments.left}
                                text={<FormattedMessage id='Profile_Renewal_Action.name' />}
                            />
                            <Label
                                left={sizes.xs}
                                textAlign={alignments.left}
                                text={`${clientFirstName} ${clientLastName}`}
                            />
                        </Container>
                    </Column>
                    <Column xs={4}>
                        <Container horizontalAlignment={alignments.left} verticalAlignment={alignments.center}>
                            <Label
                                bold
                                left={sizes.xs}
                                textAlign={alignments.left}
                                text={<FormattedMessage id='Profile_Renewal_Action.address' />}
                            />
                            <Label left={sizes.xs} textAlign={alignments.left} text={clientAddress} />
                        </Container>
                    </Column>
                    <Column xs={4}>
                        <Container horizontalAlignment={alignments.left} verticalAlignment={alignments.center}>
                            <Label
                                bold
                                left={sizes.xs}
                                textAlign={alignments.left}
                                text={<FormattedMessage id='Profile_Renewal_Action.contact' />}
                            />
                            <Label left={sizes.xs} textAlign={alignments.left} text={clientContact} />
                        </Container>
                    </Column>
                </Row>
                {priorPolicy && (
                    <Row>
                        <Column>
                            <SecondaryButton
                                text={<FormattedMessage id='Profile_Renewal_Action.viewPriorPolicy' />}
                                clickEvent={() => {
                                    window.location = `${props.context.configuration.policyWeb}/profile?entity=${priorPolicy}`;
                                }}
                            />
                        </Column>
                    </Row>
                )}
                {props.context.session.userType !== 'broker' &&
                    props.policySummary.discounts &&
                    props.policySummary.discounts.length > 0 && (
                        <ProfileSummaryDiscounts discounts={props.policySummary.discounts} />
                    )}
            </Grid>
        </PolicyFactsContainer>
    );
};

export default ProfileSummaryAction;
